import { SportsApiClient, type Events } from '@collector/sportsapi-client'

import {
  BaseIncident,
  QueueIncidentError,
  QueueIncidentStatus,
} from './BaseIncident.js'

export type AddIncidentPayload = Required<
  Pick<Events.IncidentsQueue.IncidentsQueuePostPayload, 'minute' | 'second'>
> &
  Events.IncidentsQueue.IncidentsQueuePostPayload

export class AddIncident extends BaseIncident {
  readonly type = 'Add'
  readonly isConfirmable = true
  readonly uuid: string
  readonly parentUuid?: string
  readonly payload: AddIncidentPayload

  constructor(
    eventId: number,
    payload: AddIncidentPayload,
    uuid = BaseIncident.getUUID(),
    parentUuid?: string,
    status?: QueueIncidentStatus,
    time?: number,
    error?: QueueIncidentError,
  ) {
    super(eventId, status, time, error)

    this.payload = payload
    this.uuid = uuid
    this.parentUuid = parentUuid
  }

  public async process(sportsApiClient: SportsApiClient): Promise<string> {
    /**
     * POST sends `uuid` generated once with incident instance.
     * Same `uuid` prevents duplicated incidents (HTTP 409).
     */
    await sportsApiClient.Events.IncidentsQueue.post(this.eventId, this.uuid, {
      incident: this.payload,
    })

    return this.uuid
  }
}
